import { Injectable } from '@angular/core';
import amplitude from "amplitude-js";
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AmplitudeService {
  userData:any = {};

  constructor() {
    this.userData = {
      user_name:localStorage.getItem('userName'),
      user_id:localStorage.getItem('userId'),
      user_national_id:localStorage.getItem('nat'),
      user_role:localStorage.getItem('loginAs'),
      user_country_code:localStorage.getItem('userCountryCode'),
      user_phone:localStorage.getItem('userPhone'),
      user_mail:localStorage.getItem('userMail'),
      school_name:localStorage.getItem('schoolName'),
      school_id:localStorage.getItem('schoolId'),
    };
   }

  trackEvent(eventName: string, eventData: any) {    
    if(environment.live) {
      amplitude.getInstance().setUserId(this.userData?.user_id);
      amplitude.getInstance().setUserProperties(this.userData);
      amplitude.getInstance().logEvent(eventName, eventData);
    }
  }
}